<template>
    <div class="container-home">
        <!-- <div id="sideNavigation" class="sidenav">
        <a href="javascript:void(0)" class="closebtn"  v-on:click="closeNav()">&times;</a>
            <div v-for="(item, index) in data.listCatalog" @click="nextPageSelfCourse(4, item.catalogId)" :key="index">
                    <a>{{ item.catalogName }}</a>
            </div>
        </div> -->
        <div id="menu-mobile" v-if="data.listCatalog != null || data.listCatalog != []" style="display: none;">
            <div class="item-menu-mobile" v-for="(item, index) in data.listCatalog" @click="nextPageSelfCourse(4, item.catalogId)" :key="index">
                    <a class="list">{{ item.catalogName }}</a>
            </div>
        </div>
        <!-- <nav class="topnav" v-if="data.listCatalog.length>0">
            <div class="menu-catalog">
                <div class="subscribe" @click="nextPageSelfCourse(0, 0)">
                    <a>{{ $t("new.title183") }}</a>
                </div>
                <div class="nav-list" >
                    <div class="carousel">
                    <button  class='flt-left' id="arow-left" @click="slideRight()">
                        <img src="/static/images/bkh-left.png">
                    </button>
                    <div class="row flt-left">
                        
                    <div class="row-container" id="container-slide">
                        <div style="margin-left:15px" v-for="(item, index) in data.listCatalog" @click="nextPageSelfCourse(4, item.catalogId)" :key="index">
                            <div class="container1">
                                <a>{{ item.catalogName }}</a>
                            </div>
                        </div>
                        <div class="clear"></div>
                    </div>
                    
                    </div>
                    <button class='flt-right'  @click="slideLeft()">
                        <img src="/static/images/bkh-right.png">
                    </button>
                        <div class="clear"></div>
                </div>
                    <div class="catalog-mobile">
                        <a v-on:click="openNav()">
                        {{ $t("aicourse.category") }}
                        </a>
                    </div>
                </div>
            </div>
        </nav> -->
        <!-- Swiper -->
        <div class="swiper mySwiper" v-swiper:mySwiper="swiperOption1" v-if="data.listCatalog.length>0">
            <div class="swiper-wrapper">
                <div class="swiper-slide"><a class="name_catalog" @click="nextPageSelfCourseAll()">{{ $t("new.title221") }}</a></div>
                <div class="swiper-slide" v-for="(item, index) in data.listCatalog" @click="nextPageSelfCourse(4, item.catalogId)" :key="index">
                    <a class="name_catalog">{{ item.catalogName }}</a>
                </div>
            </div>
            <div class="swiper-button-next catalog-next"><img src="../../../static/images/arrow-right-1.png" style="width:20px; height:20px" alt=""></div>
            <div class="swiper-button-prev catalog-prev"><img src="../../../static/images/arrow-left-1.png" style="width:20px; height:20px" alt=""></div>
        </div>
    </div>
</template>

<script>
    import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
    import "swiper/css/swiper.css";
    export default {
        data() {
            return {
                data: null,
                right : 0,
                maxMargin:900,
                jumpMargin:150,
                 swiperOption1: {
                    slidesPerView: 'auto',
                    slidesPerGroup: 1,
                    // loop: true,
                    loopFillGroupWithBlank: true,
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                    },
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    initialSlide: 0,
                    mousewheel: true,
                },
            };
        },
        components: {
            Swiper,
            SwiperSlide, 
        },
         directives: {
            swiper: directive,
        },
        props: {
            dataCatatalog: {
                type: Object,
                default: {},
            }
        },
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {
            this.data = this.dataCatatalog.dataListCatalog;
            this.data.listCatalog = this.data.listCatalog.sort((a, b) => parseFloat(a.order) - parseFloat(b.order));
        },
        mounted(){
            this.init();
        },
        watch: {},
        methods: {
            init(){
            },
            nextPageSelfCourse(type, id){
                // Đi đến menu bán khóa học
                this.$router.push({
                    path: "/home/selfCourse",
                    query: {
                        type: type,
                        catalogId: id,
                    },
                });
            },
            nextPageSelfCourseAll(){
                 this.$router.push({
                    path: "/home/selfCourse",
                    query: {
                        type: 0,
                        catalogId: 0,
                    },
                });
            },
            openNav(){
                var menu = document.getElementById("menu-mobile");
                 if (menu.style.display == "none") {
                     menu.style.display = "block";
                }
                else {
                    menu.style.display = "none";
                }
            },
             //Slide menu
            slideLeft(event){
                var rowcont = document.querySelector(".row-container");
                if(this.right <= -this.maxMargin){
                   //event.preventDefault(); 
                }
                else{
                    this.right -= this.jumpMargin;
                }
                rowcont.style.marginLeft = this.right+"px";
             },
            slideRight(event){
                var rowcont = document.querySelector(".row-container");
                if(this.right==0){
                   //event.preventDefault(); 
                }
                else if(this.right >= this.maxMargin){
                   
                }
                else{
                    this.right += this.jumpMargin;
                }
                rowcont.style.marginLeft = this.right+"px";
                document.getElementById("arow-left").style.display = "block";

            },
        },
    };
</script>
<style scoped>
 /* The side navigation menu */
  h3{
    cursor: pointer;
  }
  #text{
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: 50px;
    color: white;
    transform: translate(-50%,-50%);
    -ms-transform: translate(-50%,-50%);
  }
.sidenav {
    height: 100%; /* 100% Full-height */
    width: 0; /* 0 width - change this with JavaScript */
    position: fixed; /* Stay in place */
    z-index: 1; /* Stay on top */
    top: 0;
    left: 0;
    background-color: #ffffff; /* Black*/
    overflow-x: hidden; /* Disable horizontal scroll */
    padding-top: 60px; /* Place content 60px from the top */
    transition: 0.5s; /* 0.5 second transition effect to slide in the sidenav */
}

/* The navigation menu links */
.sidenav p {
    padding: 8px 8px 0px 32px;
    text-decoration: none;
    font-size: 20px;
    color: #000;
    display: block;
    transition: 0.3s;
    font-weight: 600;
}
.sidenav a {
    padding: 8px 8px 8px 32px;
    text-decoration: none;
    font-size: 20px;
    color: #000;
    display: block;
    transition: 0.3s;
    font-weight: 400;
    cursor: pointer;
}

/* When you mouse over the navigation links, change their color */
.sidenav a:hover, .offcanvas a:focus{
    color: #7e6a6a;
}

/* Position and style the close button (top right corner) */
.sidenav .closebtn {
    position: absolute;
    top: 0;
    right: 25px;
    font-size: 36px;
    margin-left: 50px;
}

/* Style page content - use this if you want to push the page content to the right when you open the side navigation */
#main {
    transition: margin-left .5s;
    padding: 20px;
    overflow:hidden;
    width:100%;
}
body {
  overflow-x: hidden;
  font-family : arial !important;
  padding: 0px !important;
  margin: 0px !important;
}
/* Add a black background color to the top navigation */
.topnav {
    background-color: #0e4370;
    overflow: hidden;
}
.topnav .nav-list{
    margin: 0px auto;
    display: block;
    float: right;
    width: 85%;
}
.topnav .menu-catalog{
    max-width: 1200px;
    display: block;
    margin: 0px auto;
}
/* Style the links inside the navigation bar */
.topnav a {
    float: left;
    display: block;
    color: rgb(255, 255, 255);
    text-align: center;
    padding: 12px 14px;
    margin: 5px;
    text-decoration: none;
    font-size: 17px;
    line-height: 17px;
    cursor: pointer;
}
/* Change the color of links on hover */
.topnav a:hover {
    background-color: #ddd;
    color: black;
    border-radius: 10px;
}

/* Add a color to the active/current link */
.topnav a.active {
    background-color: #4CAF50;
    color: white;
}
.subscribe a{
    
    color: #00CC66;
    border-radius: 10px;
    margin-left: 0px;
    cursor: pointer;
    font-weight: 600;
    font-size: 20px;
}
.topnav .catalog-mobile{
    display: none;
    
}
.catalog-mobile a{
     background-image: linear-gradient(135deg,#02adff,#00d3ff);
    border-radius: 10px;
    margin-right: 10px;
    float: right;
    cursor: pointer;
    font-weight: 600;
}
.flt-left{
  float:left;
}
.carousel{
  width:100%;
  margin:auto;
}
.row{
  width:90%;
  padding:0;
  overflow:hidden;
  margin:auto;
}
.row-container{
  width:2000px;
  transition:0.5s;
}
.container1{
  float:left;
  display:inline;
  margin:0 5px;
}
.clear{
  clear:both;
}
.controls{
  width:100%;
  margin:auto;
}
button{
  border:none;
  padding:10px 20px;
  color:white;
  background : none;
  font-weight:bold;
  outline:none;
  border-radius:3px;
  height:43px;
  font-size: 20px;
}
.flt-right{
    position: absolute;
}
/* Swiper */
.swiper {
        max-width: 1200px;
        margin: 40px auto 0px auto;
        height: 100%;
      }
      .swiper-wrapper{
          /* padding-left: 50px; */
      }
      .swiper-slide {
        width: auto !important;
        padding: 0px 10px;
        text-align: center;
        font-size: 18px;
        background: #fff;

        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
      }
      .swiper-slide a{
          color: #000;
          cursor: pointer;
      }
      .swiper-slide a:hover{
          color: #0071c5;
      }
      .catalog-next{
          background-color: #fff;
          right: 0px !important;
      }
      .catalog-prev{
          background-color: #fff;
          left: 0px !important;
      }
      .swiper-slide img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
 @media (max-width: 1112px){
    .swiper-container {
        display: block !important;
        }
    }
    /* End swiper */
@media screen and (max-width: 600px) {
   .topnav .catalog-mobile{
        display: block;
        float: right;
        width: 70%;
    }
    .topnav .nav-list .carousel{
        display: none;
    }
    .topnav .nav-list{
    width: 50% !important;
    }
}
@media screen and (max-width: 1024px){
    .topnav .nav-list{
        width: 100%;
    }
}
@media screen and (max-height: 450px) {
    .sidenav {padding-top: 15px;}
    .sidenav a {font-size: 18px;}
   
    
}
.course{
    color: #808080;
}
/* On smaller screens, where height is less than 450px, change the style of the sidenav (less padding and a smaller font size) */

.bar{
  width: 60px;
  height: 10px;
  background-color: grey;
  margin: 5px;
  border-radius: 5px;
}
#menu-mobile{
  box-shadow: 0px 12px 18px #dadae8;
  border: 1px solid #e3e3e3;
  padding-top: 30px;
  width: 100%;
  height: 100%;
  background: #fff;
  animation: comeIn 0.5s forwards;
  margin-top: 50px;
}

.item-menu-mobile:hover{
    border-radius: 0px 10px 10px 0px;
    background: #d7eacd;
}
@keyframes comeIn {
  0%{
    position: absolute;
    left: -200px;
     z-index: 1000;
  }
   100%{
    position: absolute;
    left: 0px;
     z-index: 1000;
  }
}
#menu-mobile a{
  padding: 20px;
  line-height: 30px;
  border-radius: 10px;
  font-weight: 400;
  cursor: pointer;
  font-size: 14px;
}

.list:hover{
  color: black;
}
.name_catalog {
    font-weight: bold;
    color: #0071c5!important;
}
.name_catalog:hover {
    color: #02adff!important;
}
.swiper-button-prev.swiper-button-disabled, .swiper-button-next.swiper-button-disabled {
    display: none;
}
.swiper-button-prev, .swiper-button-next {
    top: 49%;
}
.swiper-button-prev:after, .swiper-button-next:after {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/defineSelfCourse/catalogHeader.vue